module.exports = __webpack_public_path__ + "static/media/sence2.02c262a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/sence2.png
// module id = 545
// module chunks = 0